<template>
<v-layout row wrap justify-left align-top mt-4>
    <v-flex xs6 sm3 md2 pa-3 v-for="item in scopes" :key="item.id" :class="item.id === scope ? 'motw' : ''"> 
      <MOTWListItem :id="item.id" :enabled="item.enabled" :nextUp="item.nextUp"/>
    </v-flex>
</v-layout>
</template>

<script>
import {findIndex} from 'lodash'
import manips from '@/data/manips.js'
import MOTWListItem from '@/components/MOTWListItem'

export default {
  props: {
    scope: {
      type: String,
      required: true
    }
  },
  components: {
    MOTWListItem
  },
  data: function () {
    return {
      scopes: []
    }
  },
  mounted: function () {
    if (this.scope === '*') {
      this.scopes = manips.map(manip => {
        return {
          id: manip.id,
          enabled: true
        }
      })
    } else {
      let nextUpIndex = findIndex(manips, {'id': this.scope}) + 1

      if (nextUpIndex >= manips.length) nextUpIndex = 0
      
      this.scopes = manips.map((manip) => {
        if (manip.id === this.scope) {
          return {
            id: manip.id,
            enabled: true,
            nextUp: false
          } 
        }

        return {
          id: manip.id,
          enabled: false,
          nextUp: false
        }
      })
    }
  }
}
</script>

<style scoped>
.motw {
	background: #0089a6;
	border-radius: 16px;
}
</style>
